import { Component, Input, OnInit } from '@angular/core';
import { NavMenuService } from "../../_services/navmenu.service";
import { MenuItem } from "../../_models/interfaces";
import { map, Observable, shareReplay } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Router, ActivatedRoute } from '@angular/router';
import { DropdownService } from 'src/app/_services/dropdown.service';

@Component({
  selector: 'nav-menu',
  standalone: false,
  templateUrl: './navmenu.component.html',
  styleUrls: ['./navmenu.component.scss'],
})
export class NavMenuComponent implements OnInit {
  menuItems: MenuItem[] = [];
  shouldSidenavBeOpened: boolean = true;
  openedHijo: any = null;

  @Input() drawerInstance: any;
  @Input() expanded: boolean;

  constructor(
    private navSrv: NavMenuService,
    private router: Router,
    private route: ActivatedRoute,
    private breakpointObserver: BreakpointObserver,
    private dropdownService: DropdownService
  ) { }

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(map(result => result.matches), shareReplay());

  getIconForItem(itemName: string, isChild: boolean = false): string {
    const iconMap: {[key: string]: string} = {
      // Items principales
      'Inicio': 'home',
      'Reportes': 'assessment',
      'Alumnos': 'school',
      'Admisiones': 'how_to_reg',
      'Pmp': 'psychology',
      'Informes': 'class',
      'Colaboradores': 'groups',
      'Estudio': 'library_books',
      'Reuniones': 'meeting_room',
      'Intranet': 'public',
      'Asignar paz y salvo': 'assignment_turned_in',
      'Consultar paz y salvo': 'find_in_page',
      'Plataformas': 'apps',

    };

    // Prioriza el icono que viene del backend si existe
    if (isChild && itemName in iconMap) {
      return iconMap[itemName];
    }

    return iconMap[itemName] || (isChild ? 'face' : 'link');
  }

  ngOnInit() {
    this.navSrv.getItems().subscribe((items) => {
      this.menuItems = this.navSrv.extractData(items);
      setTimeout(() => this.checkActiveRoutes(), 0);
    });

    this.isHandset$.subscribe(isHandset => {
      this.shouldSidenavBeOpened = !isHandset;
    });

    this.dropdownService.openedComponent$.subscribe((component) => {
      if (component !== this) {
        this.closeAllHijoss();
      }
    });
  }

  toggleMenu(hijo: any) {
    this.dropdownService.notifyOpen(this); // Avisar que este abrió algo

    this.menuItems.forEach(item => {
      if (item.nombre === 'Mis Hijos' && item.apps) {
        item.apps.forEach(other => {
          if (other !== hijo) {
            other.menuShown = false;
            if (other.id) {
              localStorage.setItem(`menuState_${other.id}`, 'false');
            }
          }
        });
      }
    });

    hijo.menuShown = !hijo.menuShown;
    if (hijo.id) {
      localStorage.setItem(`menuState_${hijo.id}`, hijo.menuShown.toString());
    }
  }

  closeAllHijoss() {
    this.menuItems.forEach(item => {
      if (item.nombre === 'Mis Hijos' && item.apps) {
        item.apps.forEach(hijo => {
          hijo.menuShown = false;
          if (hijo.id) {
            localStorage.setItem(`menuState_${hijo.id}`, 'false');
          }
        });
      }
    });
  }

  checkActiveRoutes() {
    const currentUrl = this.router.url;

    this.menuItems.forEach(item => {
      if (item.nombre === 'Mis Hijos' && item.apps) {
        item.apps.forEach(hijo => {
          const savedState = localStorage.getItem(`menuState_${hijo.id}`);
          hijo.menuShown = savedState ? savedState === 'true' : this.isChildActive(hijo, currentUrl);

          if (!hijo.menuShown) {
            hijo.menuShown = this.checkExternalLink(hijo, currentUrl);
          }
        });
      }
    });
  }

  isChildActive(hijo: any, currentUrl?: string): boolean {
    if (!hijo.apps || hijo.apps.length === 0) return false;

    const urlToCheck = currentUrl || this.router.url;

    return hijo.apps.some((app: any) => {
      if (app.isExterno) return false;
      return urlToCheck.startsWith(app.url) || this.router.isActive(
        this.router.createUrlTree([app.url]), {
        paths: 'subset',
        queryParams: 'ignored',
        fragment: 'ignored',
        matrixParams: 'ignored',
      });
    });
  }

  checkExternalLink(hijo: any, currentUrl: string): boolean {
    const queryParams = this.route.snapshot.queryParams;

    if (queryParams['hijoId'] && hijo.id === queryParams['hijoId']) return true;

    if (hijo.externalRoutes) {
      return hijo.externalRoutes.some((route: string) => currentUrl.includes(route));
    }

    return false;
  }

  trackByHijo(index: number, hijo: any): any {
    return hijo.id || index;
  }

  trackByApp(index: number, app: any): any {
    return app.url || index;
  }

  getHijoQueryParams(hijo: any): any {
    // if (hijo.id) {
    //   return { hijoId: hijo.id };
    // }
    return null;
  }

  navigateAndClose() {
    if (this.drawerInstance && window.innerWidth < 960) {
      this.drawerInstance.toggle();
    }
  }

  handleExternalClick(event: Event, hijo?: any) {
    event.preventDefault();
    const target = event.currentTarget as HTMLAnchorElement;
    let url = target.href;

    // if (hijo?.id) {
    //   const urlObj = new URL(url);
    //   // urlObj.searchParams.set('hijoId', hijo.id);
    //   url = urlObj.toString();
    // }

    window.open(url, '_blank');
    this.navigateAndClose();
  }
}
